import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ColourGradingForm from '../../../components/forms/ColourGradingForm';
import { useColourGradingApi } from '../../../hooks/useColourGradingApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ColourGradingDTO } from '../../../services/apiClient';

const ColourGradingCreate: React.FC = () => {
  const { create, isLoading } = useColourGradingApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Colour Gradings', href: '/admin/colourgradings' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ColourGradingDTO) => {
    try {
      await create(data);
      navigate('/admin/colourgradings');
    } catch (error) {
      console.error('Error creating ColourGrading:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/colourgradings"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ColourGrading.Edit'
    >
        <ColourGradingForm
          initialValues={{} as ColourGradingDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/colourgradings')}
        />
    </AdminLayout>
  );
};

export default ColourGradingCreate;